/**
 * 彩票类型统一枚举，全项目共用这一份，新增/修改类型只需要改这里
 * value 为传给后端的类型编码，label 为页面显示的中文名
 */
export const lotteryTypeList = [

    {value: 'ssq', label: '双色球'},
    {value: 'klb', label: '快乐8'},
    {value: 'qlc', label: '七乐彩'},
    {value: 'fcsd', label: '福彩3D'},

    //================== 体彩 ==================

    {value: 'dlt', label: '大乐透'},
    {value: 'qxc', label: '七星彩'},
    {value: 'pls', label: '排列三'},
    {value: 'plw', label: '排列五'}
]

/**
 * 根据类型编码取中文名，取不到时原样返回编码
 * @param {string} value 类型编码，如 'klb'
 * @returns {string} 中文名，如 '快乐8'
 */
export function lotteryTypeLabel(value) {
    const item = lotteryTypeList.find(t => t.value === value)
    return item ? item.label : value
}

/**
 * 各彩票类型支持的组合模式，全项目共用这一份，新增玩法只需要改这里
 *   klb 快乐8：直接填选号个数 1~10
 *   ssq 双色球：红球个数+蓝球个数，如 6+1、7+2
 *   dlt 大乐透：前区个数+后区个数，如 5+2、6+2
 *   qlc 七乐彩：30选7，7=单式选7个，8=复式选8个
 *   pls 排列三：玩法名+要填的号码个数，如 direct+3（直选单式填3位）、group6+4（组选6复式填4位）
 */
export const lotteryModeMap = {
    klb: ['10', '9', '8', '7', '6', '5', '4', '3', '2', '1'],
    ssq: ['6+1', '6+2', '7+1', '7+2'],
    dlt: ['5+2', '6+2'],
    qlc: ['7', '8'],
    pls: ['direct+3', 'direct+4', 'group3+3', 'group3+4', 'group6+3', 'group6+4']
}

/**
 * 排列三玩法说明：key 为 playType 编码，value 为页面展示文字
 *   direct 直选：按顺序猜三位数字，数字可重复
 *   group3 组选3：三位数字中有两位相同
 *   group6 组选6：三位数字互不相同
 *   加号后面的数字表示要填的号码个数：3=单式，4=复式
 */
export const plsModeDescMap = {
    'direct+3': '直选（单式）',
    'direct+4': '直选（复式·填4个号码）',
    'group3+3': '组选3（单式）',
    'group3+4': '组选3（复式·填4个号码）',
    'group6+3': '组选6（单式）',
    'group6+4': '组选6（复式·填4个号码）'
}
